import { render } from "./px-matching-interest-compact.vue?vue&type=template&id=471a5dff&scoped=true&ts=true"
import script from "./px-matching-interest-compact.vue?vue&type=script&lang=ts"
export * from "./px-matching-interest-compact.vue?vue&type=script&lang=ts"

import "./px-matching-interest-compact.vue?vue&type=style&index=0&id=471a5dff&lang=scss&scoped=true"
import "./px-matching-interest-compact.vue?vue&type=style&index=1&id=471a5dff&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-471a5dff"]])

export default __exports__